import React, { FC, SVGProps } from "react";

const RestartIcon: FC<SVGProps<SVGSVGElement>> = (props) => {
  return (
    <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M2 6.9L8.7 2L15.4 6.9V14.6C15.4 14.9713 15.2431 15.3274 14.9639 15.5899C14.6847 15.8525 14.306 16 13.9111 16H3.48889C3.09401 16 2.71531 15.8525 2.43609 15.5899C2.15686 15.3274 2 14.9713 2 14.6V6.9Z"
        stroke={`#${props.color}`}
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path d="M6.46667 16V9H10.9333V16" stroke={`#${props.color}`} strokeWidth="1.2" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
};

export default RestartIcon;
